exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pdfobject[data-v-ee39b50e] {\n    border: 1px solid #666;\n}\n", ""]);

// exports
